import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Bell, Check, ShoppingBag, Crown } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const QueenReminderAlerts = ({ token, onOpenBatch, max = 5 }) => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/api/notifications`, { headers })
      .then(r => setItems((r.data || []).filter(n => n.type === 'queen_rearing_reminder' && !n.read)))
      .catch(() => {});
  }, [token]);

  const markRead = async (id) => {
    setItems(prev => prev.filter(n => n.id !== id));
    axios.put(`${API}/api/notifications/${id}/read`, {}, { headers }).catch(() => {});
  };

  if (items.length === 0) return null;
  return (
    <div data-testid="queen-reminder-alerts" className="rounded-xl border border-amber-200 bg-gradient-to-r from-amber-50 to-white p-3 space-y-2">
      <p className="text-sm font-semibold text-amber-900 flex items-center gap-2"><Bell className="h-4 w-4" /> Queen Rearing Reminders ({items.length})</p>
      {items.slice(0, max).map(n => (
        <div key={n.id} data-testid={`queen-reminder-${n.id}`} className="flex flex-wrap items-center justify-between gap-2 bg-white rounded-lg border border-amber-100 px-3 py-2">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-stone-800 flex items-center gap-1"><Crown className="h-3.5 w-3.5 text-amber-600" />{n.title}</p>
            <p className="text-xs text-stone-500 line-clamp-2">{n.message}</p>
          </div>
          <div className="flex gap-1.5 shrink-0">
            {n.milestone === 'ready' && (
              <button data-testid={`queen-reminder-list-${n.id}`} onClick={() => navigate(`/?view=marketplace&listQueens=${n.batch_id}`)} className="text-xs px-2.5 py-1 rounded-full bg-teal-600 text-white hover:bg-teal-700 flex items-center gap-1">
                <ShoppingBag className="h-3 w-3" /> List queens
              </button>
            )}
            <button data-testid={`queen-reminder-open-${n.id}`} onClick={() => (onOpenBatch ? onOpenBatch(n.batch_id) : navigate(`/?view=queen-rearing&batch=${n.batch_id}`))} className="text-xs px-2.5 py-1 rounded-full bg-amber-600 text-white hover:bg-amber-700">
              Open batch
            </button>
            <button data-testid={`queen-reminder-read-${n.id}`} onClick={() => markRead(n.id)} className="text-xs px-2 py-1 rounded-full bg-stone-100 hover:bg-stone-200 text-stone-600 flex items-center gap-1">
              <Check className="h-3 w-3" /> Done
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
